const tableQueryModal = () => import(/* webpackChunkName: "permissions" */ '../../views/comprehensiveQuery/tableQueryModal'); // 系统设置
export default [
    {
        path: '/tableQueryModal',
        name: 'tableQueryModal',
        meta: { title: '宽表模板设置',selfFlg: 'mould', },

        component: tableQueryModal
    }
];
